import { badgeClasses } from '@mui/material/Badge';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';

export const ActionNeededBadge = styled(Badge)({
  [`& .${badgeClasses.badge}`]: {
    top: 10,
    right: 7,
  },
});
